var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, actions } from 'react-redux-form';

import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import { getFileExtension } from "../../utils/getFileExtension";
import uniqueID from "../../../shared/uniqueID";

const getFileIcon = (file) => {
  const acceptedThumbnailExtensions = ['png', 'gif', 'jpg', 'jpeg'];
  let thumbnail = /*#__PURE__*/
  _jsx("span", { "no-translate": true }, void 0, /*#__PURE__*/
  _jsx(Icon, { icon: "file" }), " file"
  );


  if (file.filename && getFileExtension(file.filename) === 'pdf') {
    thumbnail = /*#__PURE__*/
    _jsx("span", { "no-translate": true }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "file-pdf" }), " pdf"
    );

  }

  if (file.url) {
    thumbnail = /*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "link" })
    );

  }

  if (
  !file.serializedFile &&
  file.filename &&
  acceptedThumbnailExtensions.indexOf(getFileExtension(file.filename.toLowerCase())) !== -1)
  {
    thumbnail = /*#__PURE__*/_jsx("img", { src: `/api/files/${file.filename}`, alt: file.originalname });
  }
  return thumbnail;
};

const fieldModel = (file, type, index) => {
  if (type === 'attachment') return `.attachments.${index}.originalname`;
  if (file._id) return `.documents.${index}.originalname`;
  return `.documents.${index}.originalFile.name`;
};







const mapDispatchToProps = (dispatch, ownProps) => {
  const { model, type } = ownProps;
  const path = type === 'attachment' ? `${model}.attachments` : `${model}.documents`;
  return bindActionCreators(
    {
      removeFile: (index) => actions.remove(path, index)
    },
    dispatch
  );
};

const connector = connect(null, mapDispatchToProps);




const MetadataFormFiles = ({ files = [], removeFile, type }) => /*#__PURE__*/
_jsx("div", { className: "attachments-list editor" }, void 0,
files.map((file, index) => {
  const attachmentClass = file._id ? 'attachment' : 'attachment new';
  return /*#__PURE__*/(
    _jsx("div", { className: attachmentClass }, file._id || uniqueID(), /*#__PURE__*/
    _jsx("div", { className: "attachment-thumbnail" }, void 0, getFileIcon(file)), /*#__PURE__*/
    _jsx("div", { className: "attachment-name" }, void 0, /*#__PURE__*/
    _jsx(Field, { model: fieldModel(file, type, index), updateOn: "blur" }, void 0, /*#__PURE__*/
    _jsx("input", { className: "form-control" })
    )
    ), /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "btn delete-supporting-file",
      onClick: () => removeFile(index) }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "trash-alt" }), "\xA0 ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Delete file")
    )
    ));

})
);


const container = connector(MetadataFormFiles);
export { container as MetadataFormFiles };